import { type TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { CardImg } from '@sorare/core/src/components/card/CardImg';
import { DialogKey } from '@sorare/core/src/components/navigation/WithDialogs';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { useOpenDialog } from '@sorare/core/src/hooks/navigation/useOpenDialog';

import { PlaceholderSlot } from '@sorare/marketplace/src/components/commonCard/RevealPackCardsDialog/CollectionAnimationV2/CollectionAnimationClub/PlaceholderSlot';

import type { CollectionSlot_userCardCollectionSlot } from './__generated__/index.graphql';

const Root = styled.div``;

type Props = {
  userCardCollectionSlot: Nullable<CollectionSlot_userCardCollectionSlot>;
  small?: boolean;
};

export const CollectionSlot = ({
  userCardCollectionSlot,
  small = false,
}: Props) => {
  const { highlightedCardCollectionCard, cardCollectionCardsCount } =
    userCardCollectionSlot || {};
  const { anyCard } = highlightedCardCollectionCard || {};
  const isLaptopAndAbove = useIsLaptop();
  const openDialog = useOpenDialog();
  if (cardCollectionCardsCount === 0 || !anyCard) {
    return <PlaceholderSlot slot={userCardCollectionSlot} small={small} />;
  }
  return (
    <Root onClick={() => openDialog(DialogKey.card, anyCard.slug)}>
      <CardImg
        src={anyCard.pictureUrl}
        alt=""
        width={isLaptopAndAbove ? 160 : 80}
      />
    </Root>
  );
};

CollectionSlot.fragments = {
  userCardCollectionSlot: gql`
    fragment CollectionSlot_userCardCollectionSlot on UserCardCollectionSlot {
      slug
      cardCollectionCardsCount
      highlightedCardCollectionCard {
        id
        anyCard {
          slug
          pictureUrl
        }
      }
      ...PlaceholderSlot_userCardCollectionSlot
    }
    ${PlaceholderSlot.fragments.userCardCollectionSlot}
  ` as TypedDocumentNode<CollectionSlot_userCardCollectionSlot>,
};
